/**
 * The other side's video, kept showing while their camera is on (3 Nov, job 1). Turning a camera off and
 * on re-enables the same track (the wrapper's setVideoEnabled flips `enabled`), but the element showing
 * it can still be left paused, detached or frozen: a real phone stops its camera while the track is off
 * and starts it again, and WebKit (Safari, the app's web view) may not start an element's playback again
 * by itself. Each second, while frames are wanted: an element not holding the stream gets it again; a
 * paused one is played; one that has shown no new frame for STALL_TICKS seconds is attached afresh.
 * Pure, so tested.
 */
export const STALL_TICKS = 3;
export type WatchAction = 'none' | 'attach' | 'play' | 'reattach';

export function watchStep(p: {
  /** Their camera is on and this element should be showing it. */
  want: boolean;
  /** This page is hidden: nothing paints, so no frame is missed (job 4). */
  hidden?: boolean;
  /** The element holds the stream it should show. */
  attached: boolean;
  paused: boolean;
  /** A new frame was shown since the last tick. */
  advanced: boolean;
  stalledTicks: number;
}): { action: WatchAction; stalledTicks: number } {
  if (!p.want || p.hidden) return { action: 'none', stalledTicks: 0 };
  if (!p.attached) return { action: 'attach', stalledTicks: 0 };
  if (p.paused) return { action: 'play', stalledTicks: 0 };
  if (p.advanced) return { action: 'none', stalledTicks: 0 };
  const n = p.stalledTicks + 1;
  return n >= STALL_TICKS ? { action: 'reattach', stalledTicks: 0 } : { action: 'none', stalledTicks: n };
}
